var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 3.3125H8.91727L7.43306 0.5H0V20.3432H5.99137C6.90895 22.7698 9.25603 24.5 12 24.5C14.744 24.5 17.091 22.7698 18.0086 20.3432H24V3.3125ZM6.58509 1.90625L8.0693 4.71875H22.5938V8.94233H20.3038V6.00097H3.69619V8.94233H1.40625V1.90625H6.58509ZM18.8976 8.94233H5.10244V7.40722H18.8976L18.8976 8.94233ZM12 23.0938C9.23466 23.0938 6.98489 20.8439 6.98489 18.0786C6.98489 15.3133 9.23466 13.0635 12 13.0635C14.7653 13.0635 17.0151 15.3133 17.0151 18.0786C17.0151 20.844 14.7653 23.0938 12 23.0938ZM18.3638 18.9369C18.4015 18.656 18.4214 18.3696 18.4214 18.0786C18.4214 14.5378 15.5408 11.6572 12 11.6572C8.45925 11.6572 5.57864 14.5378 5.57864 18.0786C5.57864 18.3696 5.59847 18.656 5.63616 18.9369H1.40625V10.3486H22.5938V18.9369H18.3638Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.025 21.3059L15.8282 18.0786L10.025 14.8513V21.3059ZM11.4312 17.2424L12.9347 18.0786L11.4312 18.9147V17.2424Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaDrive);
export default __webpack_public_path__ + "static/media/Media_Drive.e2ef5877cb8efd5392c7287695eeec60.svg";
export { ForwardRef as ReactComponent };